// A loud strip shown whenever this copy of the website is NOT talking to the live
// Fretless server, so a test copy can never be mistaken for the real app.
//
// "Live" means the production API host below. If the live API ever moves to a
// different address, update PRODUCTION_API; until then the banner would wrongly
// appear on the live site, which is the safe way to get it wrong.
import { API } from "@/App";

const PRODUCTION_API = /fretless-production\.up\.railway\.app/;

export const isTestEnvironment = (api = API) => !PRODUCTION_API.test(api || "");

export default function TestEnvironmentBanner() {
  if (!isTestEnvironment()) return null;
  return (
    <div
      role="status"
      data-testid="test-env-banner"
      style={{
        background: "#b45309",
        color: "#fff",
        textAlign: "center",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        padding: "6px 12px",
        paddingTop: "calc(env(safe-area-inset-top) + 6px)",
      }}
    >
      Test environment · not the live Fretless · data here is fake
    </div>
  );
}
